const validators = {
  email: {
    email: {
      message: "^errors.login.invalid_email"
    }
  },     
  description:{
    length: {
      minimum: 1,
      message: "^errors.request_circle.description"
    }
  }   
};

export default validators;
